/**
 * Tenant Admin "Hours & Setup" page.
 *
 * Re-uses the shared HoursSetupEditor with the /admin API prefix. Writes
 * go through `PATCH /api/admin/restaurants/{rid}` which updates the same
 * underlying ``restaurants`` document the merchant edits via
 * `PATCH /api/merchant/restaurants/{rid}` — so a save here is instantly
 * visible to the shop owner (and vice-versa).
 */
import HoursSetupEditor from "../../components/HoursSetupEditor";

export default function AdminHours() {
    return <HoursSetupEditor apiPrefix="/admin" testidPrefix="admin-hours" />;
}
